const value = {
    CHANGE_STATUS: 'Notification about changing all Statuses for requirements to one of the available values',
    UPSERT_PROJECT: 'Creating a new project / Changing the current project',
    CREATE_APPLICATION: 'Creating a new AS Profile in the Project',
    EDIT_APPLICATION: 'Changing an existing AS Profile in the Project',
    CREATE_COMMENT_JIRA: 'Creating a new comment in Jira requirement',
    CREATE_REQUIREMENT: 'Creating a new requirement in AS',
    INCLUDE_EXCLUDE_REQUIREMENT:
      'Accepting/canceling requirements in already filled out applications (red/blue markers)',
    CREATE_TEMPLATE: 'Creating a new Requirements Template',
    EDIT_REQUIREMENT: 'Notification about a requirement change',
    CREATE_ADMIN: 'Notification about adding a new administrator (including a local administrator)',
    EDIT_ROLES_GROUP: 'Notification about changing group composition (changes in the role model, adding users)',
    EDIT_PASSWORD: 'Notification about changing local user account passwords',
    UPSERT_ADDITIONAL_COLUMN: 'Notification about changing/adding additional columns',
    CREATE_SYSTEM_ROLE: 'Notification about creating a new system or project role',
    EDIT_ADDITIONAL_COLUMN_CONTENT: 'Changing the content of an additional column',
    TRANSFER_APPLICATION: 'Transferring an AS Profile to another Project',
    COPY_APPLICATION: 'Copying an AS Profile to another Project',
    EDIT_REQUIREMENT_TEMPLATE: 'Updating a Requirements Template',
    DELETE_REQUIREMENT_TEMPLATE: 'Deleting a Requirements Template',
    REQUIREMENT_ACCEPT: 'Updating the AS requirements set after changing the requirements templates',
  };

export default value;
